const togglers = Array.from(document.querySelectorAll('.js-sub-list'));

togglers.forEach((element) => {
    element.addEventListener('click', () => {
        const list = element.nextElementSibling;
        list.classList.toggle('is-active');
    });
});



// WEBPACK FOOTER //
// ./app/scripts/components/sub-list.js